var OnboardingPageStrings = {
    checklistAddEmployees: function () { return 'Add employees'; },
    checklistAddPayment: function () { return 'Add a payment method'; },
    checklistAddBudget: function () { return 'Create a budget'; },
    checklistAddBudgetSubtext: function () {
        return 'Customize how and when your employees can order';
    },
    checklistActionButton: function () { return 'Get Started'; },
    finishOnboardingButton: function () { return 'Finish Onboarding'; },
    expensedMeals: {
        pageTitle: function () { return 'Create your first meal budget'; },
        pageTitleForFinishOnboarding: function () {
            return 'Congratulations! You just created the first meal budget';
        },
        checklistAddEmployeesSubtext: function () {
            return 'Add the employees who will receive meal budgets';
        },
        checklistAddPaymentSubtext: function () {
            return 'You will only get charged when your employees place an order';
        },
        finishOnboardingBannerTitle: function () { return 'Your first meal budget is ready to use'; },
        finishOnboardingBannerText: function () {
            return 'We’ve emailed instructions to your employees so they can activate their meal budgets. Your payment card will be charged once they start placing DoorDash orders.';
        },
    },
    dashPass: {
        pageTitle: function () { return 'Set up DashPass for Work'; },
        pageTitleForFinishOnboarding: function () {
            return 'Congratulations! You just set up DashPass';
        },
        checklistAddEmployeesSubtext: function () {
            return 'Add the employees who will receive DashPass benefits';
        },
        checklistAddPaymentSubtext: function () {
            return 'You will be charged $9.99 per person per month';
        },
        finishOnboardingBannerTitle: function () { return 'Your DashPass benefit is ready!'; },
        finishOnboardingBannerText: function () {
            return 'We’ve emailed instructions to your employees so they can activate their DashPass. Your payment card will be charged for activated members every month.';
        },
        checklistActivate: function () { return 'Activate DashPass'; },
        checklistActivateSubtext: function () {
            return 'Activate DashPass for all employees for $9.99 per person per month.';
        },
    },
};
export default OnboardingPageStrings;
